import React from 'react';

export interface ESASparkIconProps {
  size?: number;
  radius?: number;
  className?: string;
}

/**
 * ESA identity icon — indigo-to-purple gradient rounded rect with a sparkle
 * star. Gradient uses theme-aware `--gaxl-esa-accent` → `--gaxl-indigo-light`
 * tokens from the @growthaxl/web-foundation design system.
 */
export function ESASparkIcon({
  size = 28,
  radius = 7,
  className,
}: ESASparkIconProps): React.ReactElement {
  const gid = `esaSparkGrad_${size}_${radius}`;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 28 28"
      fill="none"
      className={`shrink-0 block ${className ?? ''}`}
      aria-hidden="true"
    >
      <defs>
        <linearGradient
          id={gid}
          x1="0"
          y1="0"
          x2="28"
          y2="28"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#6366f1" />
          <stop offset="1" stopColor="#a78bfa" />
        </linearGradient>
      </defs>
      <rect width="28" height="28" rx={radius} fill={`url(#${gid})`} />
      {/* Main sparkle star */}
      <path
        d="M12 6.5 L13.4 11.6 L18.5 13 L13.4 14.4 L12 19.5 L10.6 14.4 L5.5 13 L10.6 11.6 Z"
        fill="#fff"
      />
      {/* Small + cross top-right */}
      <path
        d="M20.5 6.5 V10.5 M18.5 8.5 H22.5"
        stroke="#fff"
        strokeWidth="1.7"
        strokeLinecap="round"
      />
      {/* Small dot bottom-left */}
      <circle cx="7.2" cy="20.5" r="1" fill="#fff" opacity="0.85" />
    </svg>
  );
}
